import { useMutation, useQueryClient } from "@tanstack/react-query";

import Sentry from "@similarweb/sentry-logger";

import { translate } from "app/filters/i18nFilter";
import { apiClient, getQueryKey } from "app/modules/api-client";
import { NEWS_LEVER_ERROR } from "app/pages/activation/components/Shared/Subscriptions/texts";
import { useToasts } from "app/pages/activation/hooks/helpers/useToasts";

type UseUnsubscribeFromCompetitorUpdatesMutationParams = {
    activationSetId: string;
};

export const useUnsubscribeFromCompetitorUpdatesMutation = ({
    activationSetId,
}: UseUnsubscribeFromCompetitorUpdatesMutationParams) => {
    const queryClient = useQueryClient();
    const { showErrorToast } = useToasts();

    return useMutation({
        mutationFn: () => apiClient.Alerts.activationCompetitorUpdatesSubscriptionsDelete(activationSetId),
        onError: (error) => {
            Sentry.errorTracker({
                e: error,
                message: "Error in Alerts.activationCompetitorUpdatesSubscriptionsDelete request",
                level: "error",
                params: {
                    extra: {
                        activationSetId,
                    },
                },
            });

            showErrorToast(translate(NEWS_LEVER_ERROR));
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: getQueryKey({
                    tag: "Alerts",
                    methodName: "activationCompetitorUpdatesSubscriptionsDetail",
                    args: [activationSetId],
                }),
                refetchType: "all",
            });
        },
    });
};
